const apiKeyTemplate = require("./api_key.html.slim")
declare var angular

export class ApiKeyGenerator {
  static $inject = ['$scope', 'users', 'brand']

  key: any = {};
  keys;
  step = 'generate'
  brandFullName: string;
  selectedKey;

  constructor(
    public $scope,
    private users,
    private brand
  ) {
    this.brandFullName = this.brand.getBrandFullName();
    this.getApiKeys();
  }

  getApiKeys() {
    this.users.getApiKeys()
      .then(keys => {
        this.keys = keys.apiKeys;
      })
  }

  startKeyGeneration() {
    this.$scope.apiKeyGeneratorDialog.show();
  }

  generateKey(name) {
    this.users.generateApiKey(name)
      .then(key => {
        this.step = 'success';
        this.key = key;
        this.getApiKeys()
      })
  }

  deleteKeyDialog(key) {
    this.selectedKey = key;
    this.$scope.apiKeyDeleteDialog.show();
  }

  deleteKey() {
    this.users.deleteApiKey(this.selectedKey.id)
      .then(() => {
        this.getApiKeys()
        this.$scope.apiKeyDeleteDialog.hide();
      })
  }

  clear() {
    this.step = 'generate'
    this.key = null
    this.$scope.apiKeyGeneratorDialog.hide()
  }

  copyText(id, event) {
    let button = event.target;
    let selectedText: any = document.querySelector("#" + id);
    selectedText.select();
    document.execCommand("copy");
    button.innerText = 'Copied';
    button.classList.remove('button-subtle');
  }
}

angular.module("wbComponents").directive("apiKeyGenerator", function() {
  return {
    restrict: "E",
    templateUrl: apiKeyTemplate,
    controller: ApiKeyGenerator,
    controllerAs: 'ctrl',
    bindToController: true
  }
})
